import { useEffect, useMemo, useRef, useState } from 'react';

import { AI_STATUS, APIRobotInfo, RobotListItem } from '@mygpt/app';

export const useBotList = (robot: APIRobotInfo | RobotListItem) => {
  const [isInit, setIsInit] = useState(false);
  const checkTimer = useRef<ReturnType<typeof setTimeout>>();
  const componentUnmount = useRef<boolean>(false);
  const isSourceEmpty = robot.all_file_count === 0 && robot.all_faq_count === 0;
  const isDocumentType = useMemo(() => {
    return robot.ai_model === 'file';
  }, [robot]);

  // const checkRobotInit = useCallback(async (id: string) => {
  //   if (checkTimer.current) clearTimeout(checkTimer.current);
  //   const res = await getRobot({ aiId: id });
  //   const { ai_status } = res.data;
  //   const isInit = ai_status === AI_STATUS.INIT;
  //   if (isInit && !componentUnmount.current) {
  //     checkTimer.current = setTimeout(() => {
  //       checkRobotInit(id);
  //     }, 5 * 1000);
  //   } else {
  //     setIsInit(isInit);
  //   }
  // }, []);

  useEffect(() => {
    if (!robot) return;
    setIsInit(!isDocumentType && robot.ai_status === AI_STATUS.INIT);
  }, [isDocumentType, robot]);

  // useEffect(() => {
  //   if (!isInit) return;
  //   checkRobotInit(robot.id);

  //   return () => {
  //     if (checkTimer.current) {
  //       clearTimeout(checkTimer.current);
  //     }
  //     componentUnmount.current = true;
  //   };
  // }, [checkRobotInit, isInit, robot.id]);

  return {
    isInit,
    isSourceEmpty,
  };
};
